import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.Toolbar.POStatus', {
    markAsCloseButton: 'CLOSE PO',
    closedStatus: 'Closed',
    markAsOpenButton: 'Switch to Open',
});
